<template>
  <div class="navbar">
    <!--  左侧logo + 面包屑  -->
    <div class="left-box">
      <breadcrumb id="breadcrumb-container" class="breadcrumb-container"/>
    </div>

    <!--  右侧铃铛 + userInfo  -->
    <div class="right-box">
      <UserPopover/>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
import UserPopover from "@/layout/components/UserPopover";

export default {
  components: {
    Breadcrumb,
    UserPopover,
  },
  data(){
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.top-item {
  display: flex;
  align-items: center;
  margin-right: 14px;
  cursor: pointer;

  img {
    width: 18px;
    height: 18px;
    margin-right: 8px;
  }
}

.navbar {
  height: 50px;
  width: 100%;
  overflow: hidden;
  left: 0;
  top: 0;
  z-index: 1002;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);

  .left-box{
    float: left;
  }
  .right-box {
    float: right;
  }
}
</style>
